import React, { Component } from 'react';
import HyperList from "../../widgets/HyperList";
import { observer } from 'mobx-react';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'


const LockedAccountHyperlist = function (props) {
    let accounts = props.store.accounts.collection;

    let lockedAccounts = accounts.filter(account => {
        if (account.accountStatusChanges.length > 0) {
            return account.accountStatusChanges[account.accountStatusChanges.length -1].status == "Locked"
        }
        return false;
    });

    const history = useHistory();

    function redirectToAccountStatus(event) {
        let accountId = event.target.value;

        history.push("/staff/AccountStatus/" + accountId);
    }

    lockedAccounts = lockedAccounts.map(account => account.include(["employer", "student"]))

    let hyperListBody = null;
    if (lockedAccounts.length > 0) {
        hyperListBody = 
            lockedAccounts.map((account) =>  
                <li className="hyperlist-item">
                    <div className="hyperlist-item-text">
                        <span className="hyperlist-item-title">
                            {account.student.name}
                        </span>
                        <span className="hyperlist-item-subtitle">
                            {account.employer.name}
                        </span>
                    </div>
                    <div className="hyperlist-item-text">
                        <button type="button" value={account.id} onClick={redirectToAccountStatus} className="btn btn-light">View</button>
                    </div>
                </li>
            )
    }
    else {
        hyperListBody = 
            (<li className="hyperlist-item">
                <div className="hyperlist-item-text">
                    <span className="hyperlist-item-title">
                        No Accounts Locked
                    </span>
                </div>
            </li>);
    }

    let hyperListTitle =(         
        <span>
            <FontAwesomeIcon icon={faLock} size="lg"/>
            <span className="ml-3">Locked Accounts</span>
        </span>
    );

    return (
        <HyperList 
            store={props.store}
            hyperListBody={hyperListBody}
            listTitle={hyperListTitle}
        />)
}

export default observer(LockedAccountHyperlist);